"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentfulEnv = void 0;
var getContentfulEnv = function () {
    // Return the 'automation' environment if we are running in Cypress
    var customEnv = window.Cypress ? 'automation' : undefined;
    return customEnv;
};
exports.getContentfulEnv = getContentfulEnv;
